import { render, staticRenderFns } from "./RestaurantSocialMgm.vue?vue&type=template&id=301040d0&scoped=true"
import script from "./RestaurantSocialMgm.vue?vue&type=script&lang=ts"
export * from "./RestaurantSocialMgm.vue?vue&type=script&lang=ts"
import style0 from "./RestaurantSocialMgm.vue?vue&type=style&index=0&id=301040d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301040d0",
  null
  
)

export default component.exports